module.exports = __webpack_public_path__ + "static/img/home_case06.507c826.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/home_case06.png
// module id = 2PeT
// module chunks = 3